'use strict'

import Axios from 'axios'
import { parseResponse, handleError } from '@/_helpers/utils.js'

export default {
  fetch (params) {
    return new Promise((resolve, reject) => {
      Axios.get('/1.0/spec-private/schlum/responses', {params})
        .then(response => {
          resolve(parseResponse(response))
        })
        .catch(err => reject(handleError(err)))
    })
  },
  fetchQuestionnaire (responseId) {
    return new Promise((resolve, reject) => {
      // Axios.get(`https://private-23df00-usa1706.apiary-mock.com/api/1.0/spec-private/schlum/questionnaire/${responseId}`)
      Axios.get(`/1.0/spec-private/schlum/questionnaire/${responseId}`)
        .then(response => {
          resolve(parseResponse(response))
        })
        .catch(err => reject(handleError(err)))
    })
  },

  fetchTestPictures (responseId) {
    return new Promise((resolve, reject) => {
      // Axios.get(`https://private-23df00-usa1706.apiary-mock.com/api/1.0/spec-private/schlum/test-pictures/${responseId}`)
      Axios.get(`/1.0/spec-private/schlum/test-pictures/${responseId}`)
        .then(response => {
          resolve(parseResponse(response))
        })
        .catch(err => reject(handleError(err)))
    })
  },

  fetchTestQuestions (responseId) {
    return new Promise((resolve, reject) => {
      // Axios.get(`https://private-23df00-usa1706.apiary-mock.com/api/1.0/spec-private/schlum/test-questions/response_id`)
      Axios.get(`/1.0/spec-private/schlum/test-questions/${responseId}`)
        .then(response => {
          resolve(parseResponse(response))
        })
        .catch(err => reject(handleError(err)))
    })
  }
}
